export enum ModalEventos {
    ABRIR = '@modal/ABRIR',
    FECHAR = '@modal/FECHAR'
}
